import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import VinJourney from './VinJourney';
import KycProcessing from './KycProcessing';

const VinJourneyPage = () => {
  const [activeTab, setActiveTab] = useState<"vin" | "kyc" | null>(null);
  const { hasFeature } = useAuth();

  useEffect(() => {
    if (hasFeature("VEHICLE")) {
      setActiveTab("vin");
    } else if (hasFeature("KYC-PROCESSING")) {
      setActiveTab("kyc");
    }
  }, [hasFeature]);

  return (
    <Box sx={{ width: "100%" }}>
      {/* Tab Navigation */}
      <Box sx={{ display: "flex", borderBottom: "2px solid #eee", mb: 2 }}>
        {hasFeature("VEHICLE") && (
          <Button
            onClick={() => setActiveTab("vin")}
            sx={{
              fontWeight: "bold",
              fontSize: "1.1rem",
              color: activeTab === "vin" ? "#E60012" : "#888",
              borderBottom:
                activeTab === "vin"
                  ? "3px solid #E60012"
                  : "3px solid transparent",
              borderRadius: 0,
              background: "none",
              boxShadow: "none",
              px: 3,
              py: 2,
              textTransform: "none",
            }}
          >
            VIN JOURNEY
          </Button>
        )}
        {hasFeature("KYC-PROCESSING") && (
          <Button
            onClick={() => setActiveTab("kyc")}
            sx={{
              fontWeight: "bold",
              fontSize: "1.1rem",
              color: activeTab === "kyc" ? "#E60012" : "#888",
              borderBottom:
                activeTab === "kyc"
                  ? "3px solid #E60012"
                  : "3px solid transparent",
              borderRadius: 0,
              background: "none",
              boxShadow: "none",
              px: 3,
              py: 2,
              textTransform: "none",
            }}
          >
            KYC PROCESSING
          </Button>
        )}
      </Box>

      {/* Conditional rendering of tables */}
      {activeTab === "vin" && <VinJourney />}
      {activeTab === "kyc" && <KycProcessing />}
    </Box>
  );
};

export default VinJourneyPage;
